import React, { Component } from "react";
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import Title from "../components/common/Title";
import AppFrame from "./Appframe/AppFrame";
import * as actionCreators from "../actions/apps";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "material-ui/IconButton";
import Delete from "material-ui/svg-icons/action/delete-forever";
import Edit from "@material-ui/icons/Edit";
import ActionButton from "../components/common/ActionButton";

import { formatSecondsForDateOnly } from "../layout/utils/timeUtils";
import Loader from "react-loader-advanced";

class ManagePrograms extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appId: props.apps.providerAppId,
      userId: props.user.userId,
      programs: props.apps.appTemplates[props.apps.providerAppId]
        ? props.apps.appTemplates[props.apps.providerAppId].programs
        : [],
    };
    this.renderTable = this.renderTable.bind(this);
    this.renderCreateNew = this.renderCreateNew.bind(this);

    this.props.getAppTemplate(this.state.userId, this.state.appId, 103);
  }

  componentWillReceiveProps(nextProps, oldProps) {
    if (nextProps.apps.providerAppId) {
      let appTemplate =
        nextProps.apps.appTemplates[nextProps.apps.providerAppId];
      if (appTemplate) {
        this.setState({
          programs: nextProps.apps.appTemplates[nextProps.apps.providerAppId]
            ? nextProps.apps.appTemplates[nextProps.apps.providerAppId].programs
            : [],
        });
      }
    }
  }

  formatDateForDisplay(date) {
    const dt = new Date(date);
    return dt.getDay() + "/" + dt.getMonth() + "/" + dt.getFullYear();
  }

  editProgram(id) {
    let link = `../edit-program`;
    if (id) {
      link += "/" + id.toString();
    }
    this.props.history.push(link);
  }

  createData(id, name, createdDate, lastModified, instructions) {
    return { id, name, createdDate, lastModified, instructions };
  }

  renderTable() {
    if (this.state.programs) {
      return (
        <TableContainer
          component={Paper}
          style={{ border: "solid 2px grey", minWidth: 900 }}
        >
          <Table aria-label="a dense table">
            <TableHead>
              <TableRow style={{ backgroundColor: "orange", color: "white" }}>
                <TableCell style={{ color: "white", width: 500 }}>
                  Program Name
                </TableCell>
                <TableCell style={{ color: "white" }} align="right">
                  Created
                </TableCell>
                <TableCell style={{ color: "white" }} align="right">
                  Last Modified
                </TableCell>
                <TableCell style={{ color: "white" }} align="right"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.programs.length === 0 && (
                <TableRow key={"NoRowsToShow"}>
                  <TableCell align="center" colSpan={5}>
                    There are no programs to display
                  </TableCell>
                </TableRow>
              )}
              {this.state.programs.map((row) => (
                <TableRow key={row.programId}>
                  <TableCell component="th" scope="row">
                    {row.programName}
                  </TableCell>
                  <TableCell align="right">
                    {formatSecondsForDateOnly(row.created.seconds)}
                  </TableCell>
                  <TableCell align="right">
                    {formatSecondsForDateOnly(row.modified.seconds)}
                  </TableCell>

                  <TableCell>
                    <IconButton
                      onClick={() => this.editProgram(row.programId)}
                      tooltip={"Edit"}
                    >
                      <Edit />
                    </IconButton>
                    {!row.systemUse && (
                      <IconButton
                        onClick={() =>
                          this.props.deleteProgram(
                            this.state.appId,
                            this.state.userId,
                            row.programId
                          )
                        }
                        tooltip={"Delete"}
                      >
                        <Delete />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      );
    } else {
      return null;
    }
  }
  renderSelectedProgram() {
    return null;
  }

  renderCreateNew() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-end",
        }}
      >
        <ActionButton
          label="Create New Program"
          onClick={() => this.editProgram()}
        />
      </div>
    );
  }
  render() {
    return (
      <AppFrame
        auth={this.props.auth}
        header="Manage Programs"
        optionsType="programs"
        whiteLabelSettings={this.props.whiteLabelSettings}
      >
        <Title
          goBack={() => this.props.history.goBack()}
          whiteLabelSettings={this.props.whiteLabelSettings}
        />
        <Loader show={this.props.apps.isLoading} message={"Loading..."} />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          <div style={{ maxWidth: 800 }}>
            {this.renderCreateNew()}
            {this.renderTable()}
          </div>
        </div>
      </AppFrame>
    );
  }
}

function mapStateToProps({ user, apps, whiteLabelSettings }) {
  return {
    user,
    apps,
    whiteLabelSettings,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ManagePrograms);



// WEBPACK FOOTER //
// ./src/layout/ManagePrograms.js